import { Dropdown, Field, Option } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

interface IGenderDropdownProps {
    selectedGenderId: string | number;
    isDisabled: boolean;
    onGenderChange: (genderId: string) => void;
}

interface IGenderOption {
    id: number;
    key: string;
}

const genderOptions: IGenderOption[] = [
    { id: 1, key: "male" },
    { id: 2, key: "female" },
    { id: 3, key: "preferNotSay" }
];

export default function GenderDropdown(props: IGenderDropdownProps) {
    const { t } = useTranslation('recruitment');

    const selectedGenderId = props.selectedGenderId?.toString() ?? "";
    const selectedOption = genderOptions.find(option => option.id.toString() === selectedGenderId);
    const selectedLabel = selectedOption
        ? t(`register.form.genderOptions.${selectedOption.key}`)
        : t("register.form.selectGender");

    const handleGenderSelected = (value?: string) => {
        if (value && genderOptions.some(option => option.id.toString() === value)) {
            props.onGenderChange(value);
        }
    };

    return (
        <Field label={t("register.form.gender")} style={{ flex: 1 }} required>
            <Dropdown
                value={selectedLabel}
                disabled={props.isDisabled}
                selectedOptions={[selectedGenderId]}
                onOptionSelect={(_, data) => handleGenderSelected(data.optionValue)}
            >
                {genderOptions.map(option => (
                    <Option key={option.id} value={option.id.toString()}>
                        {t(`register.form.genderOptions.${option.key}`)}
                    </Option>
                ))}
            </Dropdown>
        </Field>
    );
}